module.exports = __webpack_public_path__ + "static/media/Social ideas-pana.a88fbcab.svg";